import { render } from "./TransferForm.vue?vue&type=template&id=54b772a8&scoped=true&ts=true"
import script from "./TransferForm.vue?vue&type=script&lang=ts"
export * from "./TransferForm.vue?vue&type=script&lang=ts"

import "./TransferForm.vue?vue&type=style&index=0&id=54b772a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b772a8"]])

export default __exports__